import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    container: {
        backgroundColor: theme.colors.light.offWhite2,
        maxWidth: '100%',
        height: '100%',
        overflowY: 'scroll',
        padding: '36px 16px',
        transition: 'visibility 0s 1s, opacity 1s linear',
    },
    fadeOut: {
        visibility: 'hidden',
        opacity: 0,
    },
    heading: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontSize: 14,
        letterSpacing: 0.2,
        color: theme.colors.black,
        marginBottom: 12,
    },
    subheading: {
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 14,
        color: theme.colors.text.dark,
        lineHeight: 1.71,
        marginBottom: 20,
    },
    subheadingBold: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        textDecoration: 'underline',
        fontSize: 14,
        color: theme.colors.text.dark,
        lineHeight: 1.71,
        marginBottom: 20,
    },
    close: {
        ...theme.modalClose,
    },
}))
